// extracted by LIB_CSS_EXTRACT_LOADER
import "./toggle-group_module.css"
export default {"root":"root-rMX4ky"};